/**
 * Llamadas a la API relacionadas con la sesión.
 */
import { configuracionPublicaSchema, yoSchema, type Yo } from '@cdtec-backlog/contrato';
import { ErrorDeApi, solicitar } from '../../lib/api';

export const obtenerConfiguracion = () =>
  solicitar('/auth/config', { esquema: configuracionPublicaSchema });

/** Devuelve quién soy, o `null` si no hay sesión (un 401 no es un error aquí: es el caso normal sin entrar). */
export async function obtenerYo(): Promise<Yo | null> {
  try {
    return await solicitar('/auth/yo', { esquema: yoSchema });
  } catch (error) {
    if (error instanceof ErrorDeApi && error.estado === 401) return null;
    throw error;
  }
}

export const entrarEnDesarrollo = (email: string) =>
  solicitar('/auth/dev', { metodo: 'POST', cuerpo: { email } });

export const cerrarSesion = () => solicitar('/auth/salir', { metodo: 'POST' });
